// Resources API. Methods are bound to the shared ApiClient instance
// via Object.assign in src/utils/api.js.
export function createResourcesApi(client) {
  return {
    async getResources(filters = {}) {
      const params = new URLSearchParams()
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value)
      })
  
      const result = await this.call(`/resources?${params}`)
      return { data: result.data, error: null }
    },

    async getRoadmaps(filters = {}) {
      const params = new URLSearchParams()
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value)
      })
  
      const result = await this.call(`/roadmaps?${params}`)
      return { data: result.data, error: null }
    },

    async submitRoadmap(roadmapData) {
      const result = await this.call('/roadmaps', {
        method: 'POST',
        body: JSON.stringify(roadmapData)
      })
      return result
    },

    async getCourseProgress(course) {
      const params = new URLSearchParams({ course })
      const result = await this.call(`/course?${params}`)
      return { data: result.data, error: null }
    },

    async getCourses() {
      const params = new URLSearchParams({ action: 'list' })
      const result = await this.call(`/course?${params}`, { _skipAuth: true })
      return { data: result.data || [], error: null }
    },

    async getCoursesWithProgress() {
      const result = await this.call('/course?action=catalog')
      return { data: result.data, error: null }
    },

    async getCourse(slug) {
      const params = new URLSearchParams({ action: 'get', slug })
      const result = await this.call(`/course?${params}`, { _skipAuth: true })
      return { data: result.data, error: null }
    },

    async saveCourseProgress(course, lessonId, opts = {}) {
      const result = await this.call('/course', {
        method: 'POST',
        body: JSON.stringify({
          course,
          lessonId,
          score: opts.score,
          total: opts.total,
          type: opts.type
        })
      })
      return { data: result.data, error: null }
    },

    async submitResource(resourceData) {
      const result = await this.call('/resources', {
        method: 'POST',
        body: JSON.stringify(resourceData)
      })
      return { data: result.data, error: null }
    },

    async searchUsers(query, limit = 20) {
      const params = new URLSearchParams({ q: query, limit: limit.toString() })
  
      const result = await this.call(`/discovery?${params}`)
      return { data: result.data, error: null }
    },

    async getPendingResources() {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'getPendingResources' })
      })
      return { data: result.data, error: null }
    },

    async getAllResources() {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'getAllResources' })
      })
      return { data: result.data, error: null }
    },

    async getStats() {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'getStats' })
      })
      return { data: result.data, error: null }
    },

    async getResourceStats() {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'getResourceStats' })
      })
      return { data: result.data, error: null }
    },

    async updateResourceStatus(id, status, reviewNote = '') {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'updateResourceStatus', id, status, reviewNote })
      })
      return { error: null }
    },

    async deleteResource(id) {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'deleteResource', id })
      })
      return { error: null }
    },

    async createDeckAdmin(deckData) {
      const result = await this.call('/admin', {
        method: 'POST',
        body: JSON.stringify({ action: 'createDeck', deckData })
      })
      return { data: result.data, error: null }
    }
  }
}
